/*
 * Copyright (c) 2024 Pegasystems Inc.
 * All rights reserved.
 */
import ContextProcessor from '../../context/context-processor';
import type { NodeProps } from '../../contextree/types';
import { C11nEnv } from '../../interpreter/c11n-env';
import AnnotationsHandler from '..';

AnnotationsHandler.registerHandler('@P', (propertyRef: string, c11nEnv: C11nEnv, contextTreeNodeProps?: NodeProps) => {
  if (c11nEnv) {
    return c11nEnv.getValue(propertyRef);
  }
  return ContextProcessor.getLitePropertyValue(contextTreeNodeProps);
});
